module.exports = __webpack_public_path__ + "img/logo.036258be.png";